import React from 'react'
import PropTypes from 'prop-types'
import {translate} from 'react-i18next'
import Button from '@material-ui/core/Button'
import ActionModal from '../../../common/ActionModal'

const FactorSkipModal = ({ open,dismissFn, skipFn, routeData, t }) => (
  <ActionModal 
    open={open}
    content={t('Have No Factors',{ OPTIONNUM: routeData.factorsOption })}
    dismissText={t('Cancel')}
    onDismiss={dismissFn}
    buttons={[(
      <Button
        color="primary"
        onClick={skipFn}
      >{t('Skip This Step')}</Button>
    )]}
  />
)

FactorSkipModal.propTypes = {
  open: PropTypes.bool.isRequired,
  dismissFn: PropTypes.func.isRequired,
  skipFn: PropTypes.func.isRequired,
  routerData: PropTypes.object,
  t: PropTypes.func.isRequired
}

export default translate()(FactorSkipModal)



// WEBPACK FOOTER //
// ./src/components/counseling-session/enter-factors/Modals/Skip.js